var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecruitment1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 80,
    viewBox: "0 0 84 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31717",
    "data-name": "\\uC0AC\\uAC01\\uD615 31717",
    width: 84,
    height: 80,
    transform: "translate(263 4822)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31716",
    "data-name": "\\uC0AC\\uAC01\\uD615 31716",
    width: 68.101,
    height: 78.593,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_664",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 664",
    transform: "translate(-263 -4822)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1202",
    "data-name": "\\uADF8\\uB8F9 1202",
    transform: "translate(262.418 4822.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1200",
    "data-name": "\\uADF8\\uB8F9 1200",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31715",
    "data-name": "\\uC0AC\\uAC01\\uD615 31715",
    width: 60.14,
    height: 70.505,
    rx: 7.646,
    transform: "translate(3.981 4.044)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_744",
    "data-name": "\\uD328\\uC2A4 744",
    d: "M58.765,83.9l4.327,3.17,5.3-8.292",
    transform: "translate(-14.37 -26.363)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_156",
    "data-name": "\\uC120 156",
    x2: 42.338,
    transform: "translate(12.94 42.739)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_157",
    "data-name": "\\uC120 157",
    x2: 24.392,
    transform: "translate(12.94 51.952)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_158",
    "data-name": "\\uC120 158",
    x2: 24.654,
    transform: "translate(12.94 61.165)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_160",
    "data-name": "\\uC120 160",
    x2: 19.12,
    transform: "translate(35.553 16.482)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_161",
    "data-name": "\\uC120 161",
    x2: 19.12,
    transform: "translate(35.553 24.773)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_162",
    "data-name": "\\uC120 162",
    x2: 19.12,
    transform: "translate(35.553 33.065)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_745",
    "data-name": "\\uD328\\uC2A4 745",
    d: "M31.853,38.336H16.5a7.541,7.541,0,0,1,7.48-7.6h.394A7.541,7.541,0,0,1,31.853,38.336Z",
    transform: "translate(-1.674 -5.558)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_577",
    "data-name": "\\uD0C0\\uC6D0 577",
    cx: 3.15,
    cy: 3.2,
    rx: 3.15,
    ry: 3.2,
    transform: "translate(19.154 15.58)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecruitment1);
export default __webpack_public_path__ + "static/media/icon_recruitment_1.0f4be993de85be4a0d0df28cf74c3f36.svg";
export { ForwardRef as ReactComponent };